import { useQuery } from "@tanstack/react-query"
import dashboardApi from "../api/dashboard.api"
import { QueryKeys } from "./querykeys"


export const useQueryGetAdministrationDashboard = (
  businessId: number,
  params: { year: number }
) => {
  return useQuery({
    queryKey: [QueryKeys.GET_ADMINISTRATION_DASHBOARD, businessId, params.year],
    gcTime: 10 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      try {
        const res = await dashboardApi.getAdministrationDashboard(businessId, params)
        if (res.status === 200) {
          return res.data
        }
      } catch (error) {
        return { amountToPay: 0, amountToReceive: 0 }
      }
    },
    enabled: !!businessId
  })
}
